import React , { useEffect } from "react";
import "../assets/css/advertise.css";
import Footer from "./footer";

export default function Advertise() {

  useEffect(() => {
    setTimeout(() => {
      document
        .getElementById("college-top")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 50);
  }, []);

  return (
    <div className="mainnav-container" id="college-top">
      <div className="adve_section">
        <div className="adve_container">

          <div className="adve_left">
            <h3 className="adve_title">Advertise With Us</h3>
            <p className="adve_desc">
              We are the India’s most innovative and interactive education portal with an ergonomically
              designed interface which ensures the maximum conversion. campushunt.in caters the need
              of students, parents and educators seeking information on higher education. The website
              provides options of side bar banners, footer banners, text links and mailers services on
              our opt-in mailer database.
            </p>

            <h4 className="adve_subtitle">What we offer?</h4>

            <div className="adve_block">
              <h5>Educational Institutes:</h5>

              <ol type="a">
                <li>Creation of a separate page for the institute</li>
                <li>Responsive presentation of image and other creative</li>
                <li>Guaranteed rise in user interaction and click through rate</li>
                <li>Option to migrate traffic through referral link</li>
                <li>Add your own API to get instant notification of candidate seeking information</li>
              </ol>
            </div>

            <div className="adve_block">
              <h5>Advertisers:</h5>

              <ol type="a">
                <li>Ample space for third party banners</li>
                <li>Algorithm to adjust the placement of banners only on relevant pages</li>
                <li>Ad Rotation Policy to ensure the sustainable advert reach and frequency of visitors seeing the ad</li>
              </ol>

              <p className="adve_mail">
                For more information: mail us at advertising <strong>@campushunt.in</strong>
              </p>
            </div>

          </div>


          {/* RIGHT SIDE */}
          <div className="adve_right">

            <h4 className="adve_form_title">Connect With Us</h4>

            <form className="adve_form">

              <label>Name *</label>
              <input type="text" placeholder="Enter name" />

              <label>Email *</label>
              <input type="email" placeholder="Enter email" />

              <label>Contact No. *</label>
              <input type="text" placeholder="Enter contact no" />

              <label>Message</label>
              <textarea rows="4"></textarea>

              <button type="submit" className="mt-5">Submit</button>

            </form>

          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}